import style from './style.module.scss'

const LangsTopHeader = ({ langs }) => {
    if (!langs) return null

    // Not show switcher if one trad
    const langsFormated = Object.values(langs)
    if (langsFormated.length < 2) {
        return null
    }

    return (
        <div className={style.langs}>
            {langsFormated.map((lang) => (
                <a href={lang.url} key={lang.code} className={lang.active ? style.active : null}>
                    {lang.language_code.toUpperCase()}
                </a>
            ))}
        </div>
    )
}

export default LangsTopHeader
